var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeTab==0)?_c('bill',{on:{"switchTab":_vm.switchTab}}):_c('billBack',{on:{"switchTab":_vm.switchTab}})}
var staticRenderFns = []

export { render, staticRenderFns }